import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { pinThread, unpinThread } from 'bundles/discussions/actions/ThreadSettingsActions';

import _t from 'i18n!nls/discussions';

class PinThreadButton extends React.Component {
  static propTypes = {
    questionId: PropTypes.string,
    forumType: PropTypes.string,
    isPinned: PropTypes.bool,
    isError: PropTypes.bool,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof PinThreadButton.contextTypes>;

  toggleClosed = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isPinned' does not exist on type 'Readon... Remove this comment to see the full error message
    if (!this.props.isPinned) {
      this.context.executeAction(pinThread, {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
        questionId: this.props.questionId,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumType' does not exist on type 'Reado... Remove this comment to see the full error message
        forumType: this.props.forumType,
      });
    } else {
      this.context.executeAction(unpinThread, {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
        questionId: this.props.questionId,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumType' does not exist on type 'Reado... Remove this comment to see the full error message
        forumType: this.props.forumType,
      });
    }
  };

  renderErrorState() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isError' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (this.props.isError) {
      return <div className="errorMessage">{_t('Sorry, something went wrong. Try again.')}</div>;
    }

    return null;
  }

  render() {
    return (
      <button className="nostyle rc-PinThreadButton" onClick={this.toggleClosed}>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'isPinned' does not exist on type 'Readon... Remove this comment to see the full error message */}
        {this.props.isPinned ? _t('Undo Pin') : _t('Pin')}
        {this.renderErrorState()}
      </button>
    );
  }
}

export default connectToStores(PinThreadButton, ['ThreadSettingsStore'], ({ ThreadSettingsStore }) => {
  return {
    questionId: ThreadSettingsStore.getQuestionId(),
    forumType: ThreadSettingsStore.getForumType(),
    isPinned: ThreadSettingsStore.isPinned(),
    isError: ThreadSettingsStore.isError(),
  };
});
